// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Om-z","tupacHeader":"Pm-z","tupacHeader2":"Qm-z","tupacMenu":"Rm-z","tupacMenu2":"Sm-z","tupacMain":"Tm-z","tupacMain2":"Um-z"};